import Swiper from "./swiper.svg";
import Bg1 from "./bg-1.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #1";
    this.id = "1";
    this.url = "/ai/carousels/basic";
    this.description =
      "Create a simple and sleek carousel without the need for your image";
    this.common_settings = {
      elements: [
        {
          label: "Background",
          type: "background",
          key: "slide_background",
          style_key_group: "background",
          value: {
            type: "color",
            image: Bg1,
            color: "#f8f7f7",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#101828",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#0BA5EC",
        },
        {
          label: "Tertiary Color",
          type: "color",
          key: "tertiary_color",
          style_key_group: "tertiary",
          value: "#FFFFFF",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Inter",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: Swiper,
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Post Formats",
            type: "text",
            max_words: 7,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "56px",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            value: "Make your posts look good",
            type: "text",
            max_words: 7,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "18px",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Say goodbye to long, boring paragraphs",
            type: "text",
            max_words: 7,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `
We know you want your AI-generated posts to look better and catch people's attention.
Well, now you can!`,
            max_words: 35,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontWeight: {
                value: "normal",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Make our posts look like human written",
            max_words: 7,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `
Using it is super simple!

- Just choose your favourite format while generating your posts, and ta-da!
- Supergrow will create your post in that format.

How cool is that?`,
            max_words: 35,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontWeight: {
                value: "normal",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Did you find this useful?",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
          {
            label: "CTA",
            target_key: "cta_text",
            type: "text",
            value: "Follow for more tips",
            max_words: 5,
            style: {
              color: {
                key: "tertiary_color",
              },
              fontSize: {
                value: "14px",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "bold",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[1].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[2].value;
  }

  getTertiaryColor(common_settings) {
    return common_settings.elements[3].value;
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[4]?.value;
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    common_settings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getPrimaryFont(common_settings),
        }}
      >
        <div className="absolute inset-0">
          {common_settings.elements[0].value.type === "image" &&
            common_settings.elements[0].value.image && (
              <img
                className="object-cover w-full h-full"
                src={common_settings.elements[0].value.image}
                alt=""
              />
            )}
          {common_settings.elements[0].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: common_settings.elements[0].value.color,
              }}
            ></div>
          )}
        </div>
        {index === 0 && (
          <>
            <div className="relative z-10 flex flex-col items-center justify-center flex-1 gap-2 px-8 text-center">
              <div
                className="text-lg font-bold"
                style={{ color: this.getSecondaryColor(common_settings) }}
              >
                {slide.elements[1]?.style ? (
                  <MultilineView
                    element={slide.elements[1]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, common_settings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, common_settings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[1]?.value} />
                )}
              </div>
              <div
                className="text-[56px] leading-none font-bold tracking-tight"
                style={{ color: this.getPrimaryColor(common_settings) }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, common_settings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, common_settings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
            </div>

            <div className="relative flex items-center justify-center gap-4 p-6">
              <svg
                width="235"
                className="w-auto h-8"
                viewBox="0 0 235 104"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.3322 43.6627C21.1808 42.246 20.5427 41.1429 19.418 40.3534C18.304 39.5639 16.8549 39.1692 15.0704 39.1692C13.8159 39.1692 12.7398 39.3584 11.8422 39.737C10.9446 40.1155 10.2578 40.6292 9.78198 41.2781C9.30613 41.927 9.0628 42.6678 9.05199 43.5005C9.05199 44.1927 9.2088 44.7929 9.52243 45.3012C9.84687 45.8095 10.2849 46.2421 10.8364 46.5989C11.388 46.945 11.999 47.237 12.6695 47.4749C13.3401 47.7129 14.016 47.9129 14.6973 48.0752L17.812 48.8538C19.0665 49.1458 20.2723 49.5406 21.4295 50.038C22.5975 50.5355 23.6411 51.1628 24.5604 51.9198C25.4905 52.6769 26.2259 53.5907 26.7666 54.6614C27.3074 55.732 27.5777 56.9866 27.5777 58.4249C27.5777 60.3716 27.0803 62.0857 26.0853 63.5674C25.0903 65.0382 23.652 66.1899 21.7702 67.0227C19.8992 67.8446 17.6335 68.2556 14.9731 68.2556C12.3884 68.2556 10.1443 67.8554 8.24088 67.0551C6.34829 66.2548 4.86666 65.0868 3.79599 63.5511C2.73614 62.0154 2.16296 60.1445 2.07644 57.9383H7.99754C8.08406 59.0954 8.44095 60.058 9.06821 60.8258C9.69547 61.5937 10.512 62.1668 11.5178 62.5454C12.5343 62.9239 13.6699 63.1131 14.9244 63.1131C16.233 63.1131 17.3794 62.9185 18.3635 62.5291C19.3585 62.129 20.1372 61.5774 20.6995 60.8745C21.2619 60.1607 21.5485 59.328 21.5593 58.3763C21.5485 57.5111 21.2943 56.7973 20.7969 56.2349C20.2994 55.6617 19.6018 55.1859 18.7042 54.8074C17.8174 54.418 16.7792 54.072 15.5895 53.7692L11.8098 52.7958C9.07362 52.0929 6.91066 51.0276 5.32088 49.6C3.74192 48.1617 2.95244 46.2529 2.95244 43.8736C2.95244 41.9161 3.48236 40.202 4.54221 38.7312C5.61288 37.2604 7.06747 36.1194 8.90599 35.3083C10.7445 34.4864 12.8263 34.0754 15.1515 34.0754C17.5092 34.0754 19.5748 34.4864 21.3484 35.3083C23.1329 36.1194 24.5334 37.2496 25.55 38.6987C26.5665 40.1371 27.0911 41.7918 27.1235 43.6627H21.3322ZM37.8261 67.7527L30.7857 42.8354H36.7717L41.1517 60.3554H41.3788L45.8561 42.8354H51.7772L56.2545 60.258H56.4979L60.813 42.8354H66.8152L59.7585 67.7527H53.6427L48.9708 50.914H48.6301L43.9581 67.7527H37.8261ZM70.9153 67.7527V42.8354H76.7878V67.7527H70.9153ZM73.8678 39.299C72.9377 39.299 72.1374 38.9907 71.4669 38.3743C70.7964 37.747 70.4611 36.9954 70.4611 36.1194C70.4611 35.2326 70.7964 34.481 71.4669 33.8645C72.1374 33.2373 72.9377 32.9236 73.8678 32.9236C74.8087 32.9236 75.6089 33.2373 76.2686 33.8645C76.9392 34.481 77.2744 35.2326 77.2744 36.1194C77.2744 36.9954 76.9392 37.747 76.2686 38.3743C75.6089 38.9907 74.8087 39.299 73.8678 39.299ZM82.8265 77.0967V42.8354H88.6016V46.9558H88.9422C89.2451 46.3502 89.6722 45.7067 90.2238 45.0254C90.7753 44.3332 91.5216 43.7438 92.4625 43.2572C93.4033 42.7597 94.6038 42.511 96.0638 42.511C97.9888 42.511 99.7246 43.003 101.271 43.9872C102.828 44.9605 104.061 46.4043 104.97 48.3185C105.889 50.2219 106.349 52.5579 106.349 55.3265C106.349 58.0626 105.9 60.3878 105.002 62.302C104.105 64.2162 102.883 65.6762 101.336 66.682C99.7895 67.6878 98.0375 68.1907 96.08 68.1907C94.6525 68.1907 93.4682 67.9528 92.5273 67.4769C91.5865 67.0011 90.8294 66.4279 90.2562 65.7574C89.6939 65.076 89.2559 64.4325 88.9422 63.8269H88.6989V77.0967H82.8265ZM88.5854 55.294C88.5854 56.9054 88.8125 58.3168 89.2667 59.528C89.7317 60.7393 90.3968 61.6856 91.262 62.3669C92.138 63.0374 93.1979 63.3727 94.4416 63.3727C95.7393 63.3727 96.8262 63.0266 97.7022 62.3345C98.5782 61.6315 99.2379 60.6744 99.6813 59.4631C100.136 58.2411 100.363 56.8514 100.363 55.294C100.363 53.7475 100.141 52.374 99.6976 51.1736C99.2541 49.9732 98.5944 49.0323 97.7184 48.3509C96.8424 47.6696 95.7502 47.3289 94.4416 47.3289C93.187 47.3289 92.1218 47.6588 91.2458 48.3185C90.3698 48.9782 89.7047 49.9029 89.2505 51.0925C88.8071 52.2821 88.5854 53.6826 88.5854 55.294ZM122.409 68.2394C119.91 68.2394 117.753 67.7202 115.936 66.682C114.13 65.633 112.74 64.1514 111.767 62.2371C110.794 60.3121 110.307 58.0464 110.307 55.44C110.307 52.8769 110.794 50.6275 111.767 48.6916C112.751 46.7449 114.124 45.2309 115.887 44.1494C117.65 43.0571 119.721 42.511 122.1 42.511C123.636 42.511 125.085 42.7597 126.448 43.2572C127.821 43.7438 129.033 44.5009 130.082 45.5283C131.142 46.5557 131.974 47.8643 132.58 49.454C133.186 51.033 133.488 52.9148 133.488 55.0994V56.9H113.065V52.9418H127.859C127.848 51.8171 127.605 50.8167 127.129 49.9407C126.653 49.0539 125.988 48.3563 125.134 47.8481C124.29 47.3398 123.306 47.0856 122.182 47.0856C120.981 47.0856 119.927 47.3776 119.018 47.9616C118.11 48.5348 117.401 49.2918 116.893 50.2327C116.396 51.1628 116.141 52.1848 116.131 53.2987V56.754C116.131 58.2032 116.396 59.4469 116.926 60.4851C117.455 61.5125 118.196 62.302 119.148 62.8536C120.1 63.3943 121.214 63.6647 122.49 63.6647C123.344 63.6647 124.117 63.5457 124.81 63.3078C125.502 63.0591 126.102 62.6968 126.61 62.2209C127.118 61.7451 127.502 61.1557 127.762 60.4527L133.245 61.0691C132.899 62.5183 132.239 63.7837 131.266 64.8651C130.303 65.9358 129.071 66.7685 127.567 67.3634C126.064 67.9474 124.344 68.2394 122.409 68.2394Z"
                  fill={this.getPrimaryColor(common_settings)}
                />
                <path
                  d="M170.389 67.587C170.1 67.2807 169.866 67.0216 169.621 66.7754C165.031 62.1842 160.44 57.5926 155.849 53.0005C152.817 49.9641 151.567 46.2868 152.347 42.0878C153.202 37.4872 155.936 34.2728 160.408 32.8005C164.979 31.2976 169.174 32.2269 172.658 35.5637C176.496 39.2421 180.196 43.0595 183.957 46.8228C184.982 47.8487 185.982 48.8981 187.036 49.9817C187.295 49.7462 187.481 49.5813 187.655 49.4069C190.475 46.5966 193.232 43.718 196.128 40.9865C200.401 36.956 205.535 35.1621 211.403 35.5543C217.174 35.9418 221.827 38.5484 225.613 42.8405C228.708 46.3493 231.118 50.2609 232.703 54.6743C234.49 59.5959 235.19 64.846 234.756 70.064C234.305 75.6152 232.715 80.7977 229.856 85.5668C225.194 93.3335 218.573 98.7209 209.983 101.635C205.623 103.123 201.012 103.733 196.415 103.43C189.578 102.987 183.308 100.839 177.665 96.9C174.7 94.8282 172.222 92.231 169.69 89.6904C168.458 88.4548 167.151 87.2688 166.082 85.9025C161.525 80.0839 163.361 71.4538 169.843 67.9168C169.992 67.8331 170.14 67.7377 170.389 67.587ZM226.912 67.0793C226.726 65.3844 226.638 63.6718 226.335 61.9981C225.392 56.785 223.113 52.2043 219.587 48.2397C217.884 46.3245 215.941 44.7592 213.435 44.089C208.769 42.8428 204.663 43.8817 201.215 47.3033C197.481 51.0065 193.773 54.7367 190.037 58.4398C188.27 60.1866 185.87 60.163 184.112 58.4127C181.041 55.3503 177.975 52.2852 174.913 49.2173C172.332 46.6378 169.752 44.0584 167.171 41.4789C165.893 40.2092 164.163 39.8758 162.625 40.5672C159.938 41.7745 159.399 45.1019 161.565 47.2668C168.012 53.7261 174.465 60.1799 180.923 66.6282C183.92 69.6254 186.914 72.6258 189.906 75.6293C191.202 76.9332 191.499 78.7423 190.74 80.2912C189.499 82.8247 186.253 83.3618 184.203 81.3513C182.3 79.482 180.434 77.5751 178.535 75.6976C177.387 74.5633 175.984 74.2076 174.469 74.7047C171.504 75.6788 170.692 79.2005 172.892 81.449C174.718 83.3147 176.579 85.1463 178.428 86.9849C182.8 91.337 188.006 94.0614 194.116 95.026C199.169 95.827 204.079 95.2997 208.847 93.4442C219.699 89.1886 226.812 78.727 226.912 67.0793Z"
                  fill={this.getPrimaryColor(common_settings)}
                />
                <path
                  d="M159.8 16.205C160.589 16.205 161.364 16.1979 162.14 16.205C164.485 16.2297 166.262 18.0636 166.203 20.4004C166.155 22.4263 164.437 24.2461 162.413 24.2673C158.213 24.3121 154.012 24.3121 149.81 24.2673C147.808 24.2473 146.041 22.4605 146.02 20.4664C145.984 16.2882 145.984 12.108 146.02 7.9259C146.038 5.81873 147.886 4.09437 150.015 4.08612C152.184 4.0767 154.003 5.79164 154.079 7.92472C154.102 8.62318 154.079 9.32282 154.079 10.1744C154.378 9.95532 154.55 9.83989 154.708 9.71269C159.569 5.8258 165.027 3.11676 171.031 1.51253C175.599 0.298174 180.259 -0.236568 184.969 0.0979402C195.784 0.870606 205.228 4.88823 213.083 12.4147C214.791 14.0495 216.336 15.8728 217.815 17.7208C219.555 19.8963 218.751 22.8775 216.257 23.9634C214.567 24.6984 212.642 24.2049 211.466 22.676C209.696 20.3443 207.66 18.2282 205.397 16.371C200.76 12.6137 195.527 10.0978 189.679 8.89408C181.683 7.24981 174.003 8.25569 166.638 11.748C164.353 12.8349 162.19 14.1636 160.188 15.7114C160.065 15.8075 159.947 15.9097 159.835 16.0177C159.813 16.0365 159.82 16.086 159.8 16.205Z"
                  fill={this.getSecondaryColor(common_settings)}
                />
                <path
                  d="M226.912 67.0809C226.814 78.7286 219.701 89.1902 208.849 93.4457C204.087 95.313 199.173 95.8423 194.109 95.0335C187.999 94.0688 182.793 91.3445 178.421 86.9923C176.572 85.1502 174.711 83.3186 172.885 81.4565C170.685 79.208 171.496 75.685 174.462 74.7121C175.977 74.2151 177.38 74.5708 178.528 75.7051C180.427 77.579 182.297 79.4859 184.196 81.3587C186.245 83.3705 189.496 82.8334 190.733 80.2986C191.492 78.7498 191.191 76.9406 189.899 75.6367C186.915 72.6262 183.921 69.6258 180.916 66.6356C174.463 60.1818 168.011 53.728 161.558 47.2742C159.396 45.1094 159.936 41.782 162.618 40.5747C164.156 39.8833 165.886 40.2213 167.164 41.4863C169.756 44.0587 172.336 46.6382 174.906 49.2248C177.969 52.2871 181.035 55.3523 184.105 58.4202C185.863 60.1705 188.268 60.194 190.03 58.4473C193.766 54.7441 197.474 51.0139 201.208 47.3108C204.656 43.8891 208.762 42.8503 213.428 44.0964C215.934 44.7666 217.876 46.3343 219.58 48.2471C223.106 52.2118 225.381 56.7924 226.327 62.0055C226.636 63.6734 226.723 65.386 226.912 67.0809Z"
                  fill="white"
                />
              </svg>
            </div>
          </>
        )}
        {index === carouselLength - 1 && (
          <>
            <div className="relative z-10 flex flex-col items-center justify-center flex-1 gap-2 px-8 text-center">
              <div
                className="text-5xl font-bold leading-none tracking-tight"
                style={{ color: this.getPrimaryColor(common_settings) }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, common_settings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, common_settings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>

              <div
                className="px-6 py-2 text-sm font-bold tracking-wider rounded-lg shadow-lg -rotate-3"
                style={{
                  color: this.getTertiaryColor(common_settings),
                  backgroundColor: this.getSecondaryColor(common_settings),
                }}
              >
                {slide.elements[1]?.style ? (
                  <MultilineView
                    element={slide.elements[1]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, common_settings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, common_settings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[1]?.value} />
                )}
              </div>
            </div>
          </>
        )}
        {index !== carouselLength - 1 && index !== 0 && (
          <>
            <div className="relative z-10 flex flex-col items-start justify-center flex-1 gap-2 px-8">
              <p
                className="text-2xl font-bold"
                style={{ color: this.getSecondaryColor(common_settings) }}
              >
                {index < 10 ? "0" + index : index}
              </p>
              <div
                className="text-4xl font-bold leading-none tracking-tight"
                style={{ color: this.getPrimaryColor(common_settings) }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, common_settings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, common_settings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
              <div
                className="text-sm font-normal"
                style={{ color: this.getPrimaryColor(common_settings) }}
              >
                {slide.elements[1]?.style ? (
                  <MultilineView
                    element={slide.elements[1]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, common_settings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, common_settings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[1]?.value} />
                )}
              </div>
            </div>

            <div className="relative flex items-center justify-center gap-4 p-6">
              <svg
                width="235"
                className="w-auto h-8"
                viewBox="0 0 235 104"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.3322 43.6627C21.1808 42.246 20.5427 41.1429 19.418 40.3534C18.304 39.5639 16.8549 39.1692 15.0704 39.1692C13.8159 39.1692 12.7398 39.3584 11.8422 39.737C10.9446 40.1155 10.2578 40.6292 9.78198 41.2781C9.30613 41.927 9.0628 42.6678 9.05199 43.5005C9.05199 44.1927 9.2088 44.7929 9.52243 45.3012C9.84687 45.8095 10.2849 46.2421 10.8364 46.5989C11.388 46.945 11.999 47.237 12.6695 47.4749C13.3401 47.7129 14.016 47.9129 14.6973 48.0752L17.812 48.8538C19.0665 49.1458 20.2723 49.5406 21.4295 50.038C22.5975 50.5355 23.6411 51.1628 24.5604 51.9198C25.4905 52.6769 26.2259 53.5907 26.7666 54.6614C27.3074 55.732 27.5777 56.9866 27.5777 58.4249C27.5777 60.3716 27.0803 62.0857 26.0853 63.5674C25.0903 65.0382 23.652 66.1899 21.7702 67.0227C19.8992 67.8446 17.6335 68.2556 14.9731 68.2556C12.3884 68.2556 10.1443 67.8554 8.24088 67.0551C6.34829 66.2548 4.86666 65.0868 3.79599 63.5511C2.73614 62.0154 2.16296 60.1445 2.07644 57.9383H7.99754C8.08406 59.0954 8.44095 60.058 9.06821 60.8258C9.69547 61.5937 10.512 62.1668 11.5178 62.5454C12.5343 62.9239 13.6699 63.1131 14.9244 63.1131C16.233 63.1131 17.3794 62.9185 18.3635 62.5291C19.3585 62.129 20.1372 61.5774 20.6995 60.8745C21.2619 60.1607 21.5485 59.328 21.5593 58.3763C21.5485 57.5111 21.2943 56.7973 20.7969 56.2349C20.2994 55.6617 19.6018 55.1859 18.7042 54.8074C17.8174 54.418 16.7792 54.072 15.5895 53.7692L11.8098 52.7958C9.07362 52.0929 6.91066 51.0276 5.32088 49.6C3.74192 48.1617 2.95244 46.2529 2.95244 43.8736C2.95244 41.9161 3.48236 40.202 4.54221 38.7312C5.61288 37.2604 7.06747 36.1194 8.90599 35.3083C10.7445 34.4864 12.8263 34.0754 15.1515 34.0754C17.5092 34.0754 19.5748 34.4864 21.3484 35.3083C23.1329 36.1194 24.5334 37.2496 25.55 38.6987C26.5665 40.1371 27.0911 41.7918 27.1235 43.6627H21.3322ZM37.8261 67.7527L30.7857 42.8354H36.7717L41.1517 60.3554H41.3788L45.8561 42.8354H51.7772L56.2545 60.258H56.4979L60.813 42.8354H66.8152L59.7585 67.7527H53.6427L48.9708 50.914H48.6301L43.9581 67.7527H37.8261ZM70.9153 67.7527V42.8354H76.7878V67.7527H70.9153ZM73.8678 39.299C72.9377 39.299 72.1374 38.9907 71.4669 38.3743C70.7964 37.747 70.4611 36.9954 70.4611 36.1194C70.4611 35.2326 70.7964 34.481 71.4669 33.8645C72.1374 33.2373 72.9377 32.9236 73.8678 32.9236C74.8087 32.9236 75.6089 33.2373 76.2686 33.8645C76.9392 34.481 77.2744 35.2326 77.2744 36.1194C77.2744 36.9954 76.9392 37.747 76.2686 38.3743C75.6089 38.9907 74.8087 39.299 73.8678 39.299ZM82.8265 77.0967V42.8354H88.6016V46.9558H88.9422C89.2451 46.3502 89.6722 45.7067 90.2238 45.0254C90.7753 44.3332 91.5216 43.7438 92.4625 43.2572C93.4033 42.7597 94.6038 42.511 96.0638 42.511C97.9888 42.511 99.7246 43.003 101.271 43.9872C102.828 44.9605 104.061 46.4043 104.97 48.3185C105.889 50.2219 106.349 52.5579 106.349 55.3265C106.349 58.0626 105.9 60.3878 105.002 62.302C104.105 64.2162 102.883 65.6762 101.336 66.682C99.7895 67.6878 98.0375 68.1907 96.08 68.1907C94.6525 68.1907 93.4682 67.9528 92.5273 67.4769C91.5865 67.0011 90.8294 66.4279 90.2562 65.7574C89.6939 65.076 89.2559 64.4325 88.9422 63.8269H88.6989V77.0967H82.8265ZM88.5854 55.294C88.5854 56.9054 88.8125 58.3168 89.2667 59.528C89.7317 60.7393 90.3968 61.6856 91.262 62.3669C92.138 63.0374 93.1979 63.3727 94.4416 63.3727C95.7393 63.3727 96.8262 63.0266 97.7022 62.3345C98.5782 61.6315 99.2379 60.6744 99.6813 59.4631C100.136 58.2411 100.363 56.8514 100.363 55.294C100.363 53.7475 100.141 52.374 99.6976 51.1736C99.2541 49.9732 98.5944 49.0323 97.7184 48.3509C96.8424 47.6696 95.7502 47.3289 94.4416 47.3289C93.187 47.3289 92.1218 47.6588 91.2458 48.3185C90.3698 48.9782 89.7047 49.9029 89.2505 51.0925C88.8071 52.2821 88.5854 53.6826 88.5854 55.294ZM122.409 68.2394C119.91 68.2394 117.753 67.7202 115.936 66.682C114.13 65.633 112.74 64.1514 111.767 62.2371C110.794 60.3121 110.307 58.0464 110.307 55.44C110.307 52.8769 110.794 50.6275 111.767 48.6916C112.751 46.7449 114.124 45.2309 115.887 44.1494C117.65 43.0571 119.721 42.511 122.1 42.511C123.636 42.511 125.085 42.7597 126.448 43.2572C127.821 43.7438 129.033 44.5009 130.082 45.5283C131.142 46.5557 131.974 47.8643 132.58 49.454C133.186 51.033 133.488 52.9148 133.488 55.0994V56.9H113.065V52.9418H127.859C127.848 51.8171 127.605 50.8167 127.129 49.9407C126.653 49.0539 125.988 48.3563 125.134 47.8481C124.29 47.3398 123.306 47.0856 122.182 47.0856C120.981 47.0856 119.927 47.3776 119.018 47.9616C118.11 48.5348 117.401 49.2918 116.893 50.2327C116.396 51.1628 116.141 52.1848 116.131 53.2987V56.754C116.131 58.2032 116.396 59.4469 116.926 60.4851C117.455 61.5125 118.196 62.302 119.148 62.8536C120.1 63.3943 121.214 63.6647 122.49 63.6647C123.344 63.6647 124.117 63.5457 124.81 63.3078C125.502 63.0591 126.102 62.6968 126.61 62.2209C127.118 61.7451 127.502 61.1557 127.762 60.4527L133.245 61.0691C132.899 62.5183 132.239 63.7837 131.266 64.8651C130.303 65.9358 129.071 66.7685 127.567 67.3634C126.064 67.9474 124.344 68.2394 122.409 68.2394Z"
                  fill={this.getPrimaryColor(common_settings)}
                />
                <path
                  d="M170.389 67.587C170.1 67.2807 169.866 67.0216 169.621 66.7754C165.031 62.1842 160.44 57.5926 155.849 53.0005C152.817 49.9641 151.567 46.2868 152.347 42.0878C153.202 37.4872 155.936 34.2728 160.408 32.8005C164.979 31.2976 169.174 32.2269 172.658 35.5637C176.496 39.2421 180.196 43.0595 183.957 46.8228C184.982 47.8487 185.982 48.8981 187.036 49.9817C187.295 49.7462 187.481 49.5813 187.655 49.4069C190.475 46.5966 193.232 43.718 196.128 40.9865C200.401 36.956 205.535 35.1621 211.403 35.5543C217.174 35.9418 221.827 38.5484 225.613 42.8405C228.708 46.3493 231.118 50.2609 232.703 54.6743C234.49 59.5959 235.19 64.846 234.756 70.064C234.305 75.6152 232.715 80.7977 229.856 85.5668C225.194 93.3335 218.573 98.7209 209.983 101.635C205.623 103.123 201.012 103.733 196.415 103.43C189.578 102.987 183.308 100.839 177.665 96.9C174.7 94.8282 172.222 92.231 169.69 89.6904C168.458 88.4548 167.151 87.2688 166.082 85.9025C161.525 80.0839 163.361 71.4538 169.843 67.9168C169.992 67.8331 170.14 67.7377 170.389 67.587ZM226.912 67.0793C226.726 65.3844 226.638 63.6718 226.335 61.9981C225.392 56.785 223.113 52.2043 219.587 48.2397C217.884 46.3245 215.941 44.7592 213.435 44.089C208.769 42.8428 204.663 43.8817 201.215 47.3033C197.481 51.0065 193.773 54.7367 190.037 58.4398C188.27 60.1866 185.87 60.163 184.112 58.4127C181.041 55.3503 177.975 52.2852 174.913 49.2173C172.332 46.6378 169.752 44.0584 167.171 41.4789C165.893 40.2092 164.163 39.8758 162.625 40.5672C159.938 41.7745 159.399 45.1019 161.565 47.2668C168.012 53.7261 174.465 60.1799 180.923 66.6282C183.92 69.6254 186.914 72.6258 189.906 75.6293C191.202 76.9332 191.499 78.7423 190.74 80.2912C189.499 82.8247 186.253 83.3618 184.203 81.3513C182.3 79.482 180.434 77.5751 178.535 75.6976C177.387 74.5633 175.984 74.2076 174.469 74.7047C171.504 75.6788 170.692 79.2005 172.892 81.449C174.718 83.3147 176.579 85.1463 178.428 86.9849C182.8 91.337 188.006 94.0614 194.116 95.026C199.169 95.827 204.079 95.2997 208.847 93.4442C219.699 89.1886 226.812 78.727 226.912 67.0793Z"
                  fill={this.getPrimaryColor(common_settings)}
                />
                <path
                  d="M159.8 16.205C160.589 16.205 161.364 16.1979 162.14 16.205C164.485 16.2297 166.262 18.0636 166.203 20.4004C166.155 22.4263 164.437 24.2461 162.413 24.2673C158.213 24.3121 154.012 24.3121 149.81 24.2673C147.808 24.2473 146.041 22.4605 146.02 20.4664C145.984 16.2882 145.984 12.108 146.02 7.9259C146.038 5.81873 147.886 4.09437 150.015 4.08612C152.184 4.0767 154.003 5.79164 154.079 7.92472C154.102 8.62318 154.079 9.32282 154.079 10.1744C154.378 9.95532 154.55 9.83989 154.708 9.71269C159.569 5.8258 165.027 3.11676 171.031 1.51253C175.599 0.298174 180.259 -0.236568 184.969 0.0979402C195.784 0.870606 205.228 4.88823 213.083 12.4147C214.791 14.0495 216.336 15.8728 217.815 17.7208C219.555 19.8963 218.751 22.8775 216.257 23.9634C214.567 24.6984 212.642 24.2049 211.466 22.676C209.696 20.3443 207.66 18.2282 205.397 16.371C200.76 12.6137 195.527 10.0978 189.679 8.89408C181.683 7.24981 174.003 8.25569 166.638 11.748C164.353 12.8349 162.19 14.1636 160.188 15.7114C160.065 15.8075 159.947 15.9097 159.835 16.0177C159.813 16.0365 159.82 16.086 159.8 16.205Z"
                  fill={this.getSecondaryColor(common_settings)}
                />
                <path
                  d="M226.912 67.0809C226.814 78.7286 219.701 89.1902 208.849 93.4457C204.087 95.313 199.173 95.8423 194.109 95.0335C187.999 94.0688 182.793 91.3445 178.421 86.9923C176.572 85.1502 174.711 83.3186 172.885 81.4565C170.685 79.208 171.496 75.685 174.462 74.7121C175.977 74.2151 177.38 74.5708 178.528 75.7051C180.427 77.579 182.297 79.4859 184.196 81.3587C186.245 83.3705 189.496 82.8334 190.733 80.2986C191.492 78.7498 191.191 76.9406 189.899 75.6367C186.915 72.6262 183.921 69.6258 180.916 66.6356C174.463 60.1818 168.011 53.728 161.558 47.2742C159.396 45.1094 159.936 41.782 162.618 40.5747C164.156 39.8833 165.886 40.2213 167.164 41.4863C169.756 44.0587 172.336 46.6382 174.906 49.2248C177.969 52.2871 181.035 55.3523 184.105 58.4202C185.863 60.1705 188.268 60.194 190.03 58.4473C193.766 54.7441 197.474 51.0139 201.208 47.3108C204.656 43.8891 208.762 42.8503 213.428 44.0964C215.934 44.7666 217.876 46.3343 219.58 48.2471C223.106 52.2118 225.381 56.7924 226.327 62.0055C226.636 63.6734 226.723 65.386 226.912 67.0809Z"
                  fill="white"
                />
              </svg>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default Basic;
